export const controllers = [
    // WIRELESS
    {
        name: 'RFGB-20/',
        type: 'controller',
        tech: 'wireless',
        material: 'glass',
        icons: 2,
        round: false,
        colors: ['black', 'white'],
        colorsShortcut: ['B', 'W'],
        className: 'glass-20',
        previewImage: 'glass-20',
        renderImage: 'glass',
        actuator: false,
        buttonCodes: {
            0: 'D',
            1: 'F'
        },
        price: 73.05
    },
    {
        name: 'RFGB-40/',
        type: 'controller',
        tech: 'wireless',
        material: 'glass',
        icons: 4,
        round: false,
        colors: ['black', 'white'],
        colorsShortcut: ['B', 'W'],
        className: 'glass-40',
        previewImage: 'glass-40',
        renderImage: 'glass',
        actuator: false,
        buttonCodes: {
            0: 'A',
            1: 'G',
            2: 'C',
            3: 'I'
        },
        price: 80.15
    },
    {
        name: 'RFGB-220/',
        type: 'controller',
        tech: 'wireless',
        material: 'glass',
        icons: 2,
        round: true,
        colors: ['black', 'white'],
        colorsShortcut: ['B', 'W'],
        className: 'glass-20',
        previewImage: 'glass-20-round',
        renderImage: 'glass-round',
        actuator: false,
        buttonCodes: {
            0: 'D',
            1: 'F'
        },
        price: 78.08
    },
    {
        name: 'RFGB-240/',
        type: 'controller',
        tech: 'wireless',
        material: 'glass',
        icons: 4,
        round: true,
        colors: ['black', 'white'],
        colorsShortcut: ['B', 'W'],
        className: 'glass-40',
        previewImage: 'glass-40-round',
        renderImage: 'glass-round',
        actuator: false,
        buttonCodes: {
            0: 'A',
            1: 'G',
            2: 'C',
            3: 'I'
        },
        price: 85.18
    },

    {
        name: 'RFSW-22/S',
        type: 'controller',
        tech: 'wireless',
        material: 'glass',
        icons: 2,
        round: false,
        colors: ['black', 'white'],
        colorsShortcut: ['B', 'W'],
        className: 'glass-20',
        previewImage: 'glass-20',
        renderImage: 'glass',
        actuator: true,
        actuatorDetails: {
            type: 'RFSW-22/S',
            name: '',
            refImg: 'default_controller.png',
            dinrail: false,
            numberOfChannels: 2,
            usage: 'switching',
            applianceType: 'lighting',
        },
        buttonCodes: {
            0: 'D',
            1: 'F'
        },
        price: 127.5
    },
    {
        name: 'RFSW-222/S',
        type: 'controller',
        tech: 'wireless',
        material: 'glass',
        icons: 2,
        round: true,
        colors: ['black', 'white'],
        colorsShortcut: ['B', 'W'],
        className: 'glass-20',
        previewImage: 'glass-20-round',
        renderImage: 'glass-round',
        actuator: true,
        actuatorDetails: {
            type: 'RFSW-222/S',
            name: '',
            refImg: 'default_controller.png',
            dinrail: false,
            numberOfChannels: 2,
            usage: 'switching',
            applianceType: 'lighting',
        },
        buttonCodes: {
            0: 'D',
            1: 'F'
        },
        price: 127.5
    },
    {
        name: 'RFSW-42/S',
        type: 'controller',
        tech: 'wireless',
        material: 'glass',
        icons: 4,
        round: false,
        colors: ['black', 'white'],
        colorsShortcut: ['B', 'W'],
        className: 'glass-40',
        previewImage: 'glass-40',
        renderImage: 'glass',
        actuator: true,
        actuatorDetails: {
            type: 'RFSW-42/S',
            name: '',
            refImg: 'controller_black.png',
            dinrail: false,
            numberOfChannels: 4,
            applianceType: 'lighting',
            usage: 'switching'
        },
        buttonCodes: {
            0: 'A',
            1: 'G',
            2: 'C',
            3: 'I'
        },
        price: 127.5
    },
    {
        name: 'RFSW-242/S',
        type: 'controller',
        tech: 'wireless',
        material: 'glass',
        icons: 4,
        round: true,
        colors: ['black', 'white'],
        colorsShortcut: ['B', 'W'],
        className: 'glass-40',
        previewImage: 'glass-40-round',
        renderImage: 'glass-round',
        actuator: true,
        actuatorDetails: {
            type: 'RFSW-242/S',
            name: '',
            refImg: 'controller_black_round.png',
            dinrail: false,
            numberOfChannels: 4,
            applianceType: 'lighting',
            usage: 'switching'
        },
        buttonCodes: {
            0: 'A',
            1: 'G',
            2: 'C',
            3: 'I'
        },
        price: 127.5
    },

    {
        name: 'RFDW-71/',
        type: 'controller',
        tech: 'wireless',
        material: 'glass',
        icons: 4,
        round: false,
        colors: ['black', 'white'],
        colorsShortcut: ['B', 'W'],
        className: 'glass-40',
        previewImage: 'glass-40',
        renderImage: 'glass',
        actuator: true,
        actuatorDetails: {
            type: 'RFDW-71',
            name: '',
            refImg: 'controller_black.png',
            dinrail: false,
            numberOfChannels: 4,
            applianceType: 'lighting',
            usage: 'dimming'
        },
        buttonCodes: {
            0: 'A',
            1: 'G',
            2: 'C',
            3: 'I'
        },
        price: 143.52
    },
    {
        name: 'RFDW-271/',
        type: 'controller',
        tech: 'wireless',
        material: 'glass',
        icons: 4,
        round: true,
        colors: ['black', 'white'],
        colorsShortcut: ['B', 'W'],
        className: 'glass-40',
        previewImage: 'glass-40-round',
        renderImage: 'glass-round',
        actuator: true,
        actuatorDetails: {
            type: 'RFDW-271',
            name: '',
            refImg: 'controller_black_round.png',
            dinrail: false,
            numberOfChannels: 4,
            applianceType: 'lighting',
            usage: 'dimming'
        },
        buttonCodes: {
            0: 'A',
            1: 'G',
            2: 'C',
            3: 'I'
        },
        price: 157.92
    },

    {
        name: 'RFTC-3/',
        type: 'thermostat',
        thermostatAppliance: 'fancoil',
        thermostatRequiredActuator: null,
        tech: "wireless",
        material: 'glass',
        icons: 6,
        round: false,
        colors: ['black', 'white'],
        colorsShortcut: ['B', 'W'],
        className: 'glass-thermostat-6',
        previewImage: 'rftc-3-6',
        renderImage: 'rftc',
        unremoveableIcons: true,
        actuator: false,
        defaultIconsData: [
            {
                "position": 0,
                "color": "%c",
                "icon": "controllers/%c/2C",
                "applianceId": null,
            },
            {
                "position": 1,
                "color": "%c",
                "icon": "controllers/%c/2D",
                "applianceId": null,
            },
            {
                "position": 2,
                "color": "%c",
                "icon": "controllers/%c/11L",
                "applianceId": null,
            },
            {
                "position": 3,
                "color": "%c",
                "icon": "controllers/%c/1A",
                "applianceId": null,
            },
            {
                "position": 4,
                "color": "%c",
                "icon": "controllers/%c/12C",
                "applianceId": null,
            },
            {
                "position": 5,
                "color": "%c",
                "icon": "controllers/%c/11E",
                "applianceId": null,
            }
        ],
        price: 190
    },
    {
        name: 'RFTC-3/',
        type: 'thermostat',
        thermostatAppliance: 'fancoil',
        thermostatRequiredActuator: null,
        tech: "wireless",
        material: 'glass',
        icons: 8,
        round: false,
        colors: ['black', 'white'],
        colorsShortcut: ['B', 'W'],
        className: 'glass-thermostat-8',
        iconsScale: 0.5,
        previewImage: 'rftc-3-8',
        renderImage: 'rftc',
        unremoveableIcons: true,
        actuator: false,
        defaultIconsData: [
            {
                "position": 0,
                "color": "%c",
                "icon": "controllers/%c/2C",
                "applianceId": null,
            },
            {
                "position": 1,
                "color": "%c",
                "icon": "controllers/%c/2D",
                "applianceId": null,
            },
            {
                "position": 2,
                "color": "%c",
                "icon": "controllers/%c/11L",
                "applianceId": null,
            },
            {
                "position": 3,
                "color": "red",
                "icon": "controllers/red/10C",
                "applianceId": null,
            },
            {
                "position": 4,
                "color": "green",
                "icon": "controllers/green/10A",
                "applianceId": null,
            },
            {
                "position": 5,
                "color": "%c",
                "icon": "controllers/%c/1A",
                "applianceId": null,
            },
            {
                "position": 6,
                "color": "%c",
                "icon": "controllers/%c/12C",
                "applianceId": null,
            },
            {
                "position": 7,
                "color": "%c",
                "icon": "controllers/%c/11E",
                "applianceId": null,
            }
        ],
        price: 190
    },

    /*{
        name: 'RFTC-4/',
        type: 'thermostat',
        thermostatAppliance: 'fancoil',
        thermostatRequiredActuator: {
            tech: 'wireless',
            type: 'RFSA-66M',
            applianceType: 'hvac',
            usage: 'switching',
            name: GetNameWithTranslation('6x 8A', 'channels'),
            refImg: 'RFSA-66M.png',
            icon: 'actuator_din_3',
            dinrail: true,
            numberOfChannels: 6,
            price: 125.49
        },
        tech: "wireless",
        material: 'glass',
        icons: 6,
        round: false,
        colors: ['black', 'white'],
        colorsShortcut: ['B', 'W'],
        className: 'glass-thermostat-6',
        previewImage: 'rftc-3-6',
        renderImage: 'rftc',
        unremoveableIcons: true,
        actuator: false,
        defaultIconsData: [
            {
                "position": 0,
                "color": "%c",
                "icon": "controllers/%c/2C",
                "applianceId": null,
            },
            {
                "position": 1,
                "color": "%c",
                "icon": "controllers/%c/2D",
                "applianceId": null,
            },
            {
                "position": 2,
                "color": "%c",
                "icon": "controllers/%c/11L",
                "applianceId": null,
            },
            {
                "position": 3,
                "color": "%c",
                "icon": "controllers/%c/1A",
                "applianceId": null,
            },
            {
                "position": 4,
                "color": "%c",
                "icon": "controllers/%c/12C",
                "applianceId": null,
            },
            {
                "position": 5,
                "color": "%c",
                "icon": "controllers/%c/11E",
                "applianceId": null,
            }
        ],
        price: 190
    },
    {
        name: 'RFTC-4/',
        type: 'thermostat',
        thermostatAppliance: 'fancoil',
        thermostatRequiredActuator: {
            tech: 'wireless',
            type: 'RFSA-66M',
            applianceType: 'hvac',
            usage: 'switching',
            name: GetNameWithTranslation('6x 8A', 'channels'),
            refImg: 'RFSA-66M.png',
            icon: 'actuator_din_3',
            dinrail: true,
            numberOfChannels: 6,
            price: 125.49
        },
        tech: "wireless",
        material: 'glass',
        icons: 8,
        round: false,
        colors: ['black', 'white'],
        colorsShortcut: ['B', 'W'],
        className: 'glass-thermostat-8',
        iconsScale: 0.5,
        previewImage: 'rftc-3-8',
        renderImage: 'rftc',
        unremoveableIcons: true,
        actuator: false,
        defaultIconsData: [
            {
                "position": 0,
                "color": "%c",
                "icon": "controllers/%c/2C",
                "applianceId": null,
            },
            {
                "position": 1,
                "color": "%c",
                "icon": "controllers/%c/2D",
                "applianceId": null,
            },
            {
                "position": 2,
                "color": "%c",
                "icon": "controllers/%c/11L",
                "applianceId": null,
            },
            {
                "position": 3,
                "color": "red",
                "icon": "controllers/red/10C",
                "applianceId": null,
            },
            {
                "position": 4,
                "color": "green",
                "icon": "controllers/green/10A",
                "applianceId": null,
            },
            {
                "position": 5,
                "color": "%c",
                "icon": "controllers/%c/1A",
                "applianceId": null,
            },
            {
                "position": 6,
                "color": "%c",
                "icon": "controllers/%c/12C",
                "applianceId": null,
            },
            {
                "position": 7,
                "color": "%c",
                "icon": "controllers/%c/11E",
                "applianceId": null,
            }
        ],
        price: 190
    },*/
    {
        name: 'RFTC-6/',
        type: 'thermostat',
        thermostatAppliance: 'electric',
        thermostatRequiredActuator: null,
        tech: "wireless",
        material: 'glass',
        icons: 8,
        round: false,
        colors: ['black', 'white'],
        colorsShortcut: ['B', 'W'],
        className: 'glass-thermostat-8',
        iconsScale: 0.5,
        previewImage: 'rftc-6',
        renderImage: 'rftc',
        unremoveableIcons: true,
        actuator: false,
        defaultIconsData: [
            {
                "position": 0,
                "color": "%c",
                "icon": "controllers/%c/1G",
                "applianceId": null,
            },
            {
                "position": 1,
                "color": "%c",
                "icon": "controllers/%c/1H",
                "applianceId": null,
            },
            {
                "position": 2,
                "color": "%c",
                "icon": "controllers/%c/11L",
                "applianceId": null,
            },
            {
                "position": 3,
                "color": "red",
                "icon": "controllers/%c/2I",
                "applianceId": null,
            },
            {
                "position": 4,
                "color": "green",
                "icon": "controllers/%c/2J",
                "applianceId": null,
            },
            {
                "position": 5,
                "color": "%c",
                "icon": "controllers/%c/1A",
                "applianceId": null,
            },
            {
                "position": 6,
                "color": "%c",
                "icon": "controllers/%c/1I",
                "applianceId": null,
            },
            {
                "position": 7,
                "color": "%c",
                "icon": "controllers/%c/11F",
                "applianceId": null,
            }
        ],
        price: 164.5
    },
    {
        name: 'RFTC-7/',
        type: 'thermostat',
        thermostatAppliance: 'radiator',
        thermostatRequiredActuator: 'RFATV-2',
        thermostatRequiredActuatorMaxCount: 16,
        tech: "wireless",
        material: 'glass',
        icons: 8,
        round: false,
        colors: ['black', 'white'],
        colorsShortcut: ['B', 'W'],
        className: 'glass-thermostat-8',
        iconsScale: 0.5,
        previewImage: 'rftc-7',
        renderImage: 'rftc',
        unremoveableIcons: true,
        actuator: false,
        defaultIconsData: [
            {
                "position": 0,
                "color": "%c",
                "icon": "controllers/%c/1G",
                "applianceId": null,
            },
            {
                "position": 1,
                "color": "%c",
                "icon": "controllers/%c/1H",
                "applianceId": null,
            },
            {
                "position": 2,
                "color": "%c",
                "icon": "controllers/%c/11L",
                "applianceId": null,
            },
            {
                "position": 3,
                "color": "red",
                "icon": "controllers/%c/2I",
                "applianceId": null,
            },
            {
                "position": 4,
                "color": "green",
                "icon": "controllers/%c/2J",
                "applianceId": null,
            },
            {
                "position": 5,
                "color": "%c",
                "icon": "controllers/%c/1A",
                "applianceId": null,
            },
            {
                "position": 6,
                "color": "%c",
                "icon": "controllers/%c/1I",
                "applianceId": null,
            },
            {
                "position": 7,
                "color": "%c",
                "icon": "controllers/%c/11F",
                "applianceId": null,
            }
        ],
        price: 149.5
    },
    {
        name: 'RFTC-9/',
        type: 'thermostat',
        thermostatAppliance: 'vrv',
        thermostatRequiredActuator: null,
        tech: "wireless",
        material: 'glass',
        icons: 8,
        round: false,
        colors: ['black', 'white'],
        colorsShortcut: ['B', 'W'],
        className: 'glass-thermostat-8',
        iconsScale: 0.5,
        previewImage: 'rftc-3-8',
        renderImage: 'rftc',
        unremoveableIcons: true,
        actuator: false,
        defaultIconsData: [
            {
                "position": 0,
                "color": "%c",
                "icon": "controllers/%c/2C",
                "applianceId": null,
            },
            {
                "position": 1,
                "color": "%c",
                "icon": "controllers/%c/2D",
                "applianceId": null,
            },
            {
                "position": 2,
                "color": "%c",
                "icon": "controllers/%c/11L",
                "applianceId": null,
            },
            {
                "position": 3,
                "color": "red",
                "icon": "controllers/red/10C",
                "applianceId": null,
            },
            {
                "position": 4,
                "color": "green",
                "icon": "controllers/green/10A",
                "applianceId": null,
            },
            {
                "position": 5,
                "color": "%c",
                "icon": "controllers/%c/1A",
                "applianceId": null,
            },
            {
                "position": 6,
                "color": "%c",
                "icon": "controllers/%c/12C",
                "applianceId": null,
            },
            {
                "position": 7,
                "color": "%c",
                "icon": "controllers/%c/11E",
                "applianceId": null,
            }
        ],
    },
    {
        name: 'RFTC-9/',
        type: 'thermostat',
        thermostatAppliance: 'vrv',
        thermostatRequiredActuator: null,
        tech: "wireless",
        material: 'glass',
        icons: 6,
        round: false,
        colors: ['black', 'white'],
        colorsShortcut: ['B', 'W'],
        className: 'glass-thermostat-6',
        previewImage: 'rftc-3-6',
        renderImage: 'rftc',
        unremoveableIcons: true,
        actuator: false,
        defaultIconsData: [
            {
                "position": 0,
                "color": "%c",
                "icon": "controllers/%c/2C",
                "applianceId": null,
            },
            {
                "position": 1,
                "color": "%c",
                "icon": "controllers/%c/2D",
                "applianceId": null,
            },
            {
                "position": 2,
                "color": "%c",
                "icon": "controllers/%c/11L",
                "applianceId": null,
            },
            {
                "position": 3,
                "color": "%c",
                "icon": "controllers/%c/1A",
                "applianceId": null,
            },
            {
                "position": 4,
                "color": "%c",
                "icon": "controllers/%c/12C",
                "applianceId": null,
            },
            {
                "position": 5,
                "color": "%c",
                "icon": "controllers/%c/11E",
                "applianceId": null,
            }
        ],
    },

    // Metal

    {
        name: 'RFMB-22/',
        type: 'controller',
        tech: 'wireless',
        material: 'metal',
        icons: 2,
        round: false,
        colors: ['silver', 'brass', 'black', 'copper'],
        colorsShortcut: ['SS', 'GG', 'BB', 'CC'],
        className: 'metal-20',
        previewImage: 'metal-20',
        renderImage: 'metal-2',
        actuator: false,
        buttonCodes: {
            0: 'D',
            1: 'F'
        },
        price: 142.5
    },
    {
        name: 'RFMB-42/',
        type: 'controller',
        tech: 'wireless',
        material: 'metal',
        icons: 4,
        round: false,
        colors: ['silver', 'brass', 'black', 'copper'],
        colorsShortcut: ['SS', 'GG', 'BB', 'CC'],
        className: 'metal-40',
        previewImage: 'metal-40',
        renderImage: 'metal-4',
        actuator: false,
        buttonCodes: {
            0: 'A',
            1: 'G',
            2: 'C',
            3: 'I'
        },
        price: 142.5
    },
    {
        name: 'RFMB-62/',
        type: 'controller',
        tech: 'wireless',
        material: 'metal',
        icons: 6,
        round: false,
        colors: ['silver', 'brass', 'black', 'copper'],
        colorsShortcut: ['SS', 'GG', 'BB', 'CC'],
        className: 'metal-60',
        previewImage: 'metal-60',
        renderImage: 'metal-6',
        actuator: false,
        buttonCodes: {
            0: 'A',
            1: 'D',
            2: 'G',
            3: 'C',
            4: 'F',
            5: 'I'
        },
        price: 149.5
    },

    // Plastic

    {
        name: 'RFWB-20/G',
        type: 'controller',
        tech: 'wireless',
        material: 'plastic',
        icons: 2,
        round: false,
        colors: ['black', 'white'],
        colorsShortcut: ['B', 'W'],
        className: 'plastic-20',
        previewImage: 'plastic-1',
        renderImage: 'plastic-1',
        actuator: false,
        buttonCodes: {
            0: 'D',
            1: 'F'
        },
        price: 39.31
    },
    {
        name: 'RFWB-40/G',
        type: 'controller',
        tech: 'wireless',
        material: 'plastic',
        icons: 4,
        round: false,
        colors: ['black', 'white'],
        colorsShortcut: ['B', 'W'],
        className: 'plastic-40',
        previewImage: 'plastic-2',
        renderImage: 'plastic-2',
        actuator: false,
        buttonCodes: {
            0: 'A',
            1: 'G',
            2: 'C',
            3: 'I'
        },
        price: 43.35
    },
    

    // BUS

    {
        name: "GSB3-40/S",
        type: 'controller',
        tech: 'bus',
        material: 'glass',
        icons: 4,
        round: false,
        colors: ['black', 'white'],
        colorsShortcut: ['B', 'W'],
        className: 'glass-40',
        previewImage: 'glass-40',
        renderImage: 'glass'
    },
    {
        name: "GSB3-60/S",
        type: 'controller',
        tech: 'bus',
        material: 'glass',
        icons: 6,
        round: false,
        colors: ['black', 'white'],
        colorsShortcut: ['B', 'W'],
        className: 'glass-60',
        previewImage: 'glass-60',
        renderImage: 'glass'
    },
    {
        name: "GSB3-90/S",
        type: 'controller',
        tech: 'bus',
        material: 'glass',
        icons: 9,
        round: false,
        colors: ['black', 'white'],
        colorsShortcut: ['B', 'W'],
        className: 'glass-90',
        previewImage: 'glass-90',
        renderImage: 'glass'
    },
    {
        name: "GSB3-240/S",
        type: 'controller',
        tech: 'bus',
        material: 'glass',
        icons: 4,
        round: true,
        colors: ['black', 'white'],
        colorsShortcut: ['B', 'W'],
        className: 'glass-40',
        previewImage: 'glass-40-round',
        renderImage: 'glass-round'
    },
    {
        name: "GSB3-260/S",
        type: 'controller',
        tech: 'bus',
        material: 'glass',
        icons: 6,
        round: true,
        colors: ['black', 'white'],
        colorsShortcut: ['B', 'W'],
        className: 'glass-60',
        previewImage: 'glass-60-round',
        renderImage: 'glass-round'
    },
    {
        name: "GSB3-290/S",
        type: 'controller',
        tech: 'bus',
        material: 'glass',
        icons: 9,
        round: true,
        colors: ['black', 'white'],
        colorsShortcut: ['B', 'W'],
        className: 'glass-90',
        previewImage: 'glass-90-round',
        renderImage: 'glass-round'
    },

    {
        name: 'MSB3-40/',
        type: 'controller',
        tech: 'bus',
        material: 'metal',
        icons: 4,
        round: false,
        colors: ['silver', 'brass', 'black', 'copper'],
        colorsShortcut: ['SS', 'GG', 'BB', 'CC'],
        className: 'metal-40',
        previewImage: 'metal-40',
        renderImage: 'metal-4'
    },
    {
        name: 'MSB3-60/',
        type: 'controller',
        tech: 'bus',
        material: 'metal',
        icons: 6,
        round: false,
        colors: ['silver', 'brass', 'black', 'copper'],
        colorsShortcut: ['SS', 'GG', 'BB', 'CC'],
        className: 'metal-60',
        previewImage: 'metal-60',
        renderImage: 'metal-6'
    },
    /*{
        name: 'MSB3-90/',
        type: 'controller',
        tech: 'bus',
        material: 'metal',
        icons: 9,
        round: false,
        colors: ['silver', 'brass', 'black', 'copper'],
        colorsShortcut: ['SS', 'GG', 'BB', 'CC'],
        className: 'metal-90',
        previewImage: 'metal-90',
        renderImage: 'metal-9'
    },*/

    {
        name: 'GRT3-70/',
        type: 'thermostat',
        tech: "bus",
        material: 'glass',
        icons: 7,
        round: false,
        colors: ['black', 'white'],
        colorsShortcut: ['B', 'W'],
        className: 'glass-thermostat-7',
        previewImage: 'grt3-7',
        renderImage: 'grt3',
        unremoveableIcons: true,
        defaultIconsData: [
            {
                "position": 0,
                "color": "%c",
                "icon": "controllers/%c/1H",
                "applianceId": null,
            },
            {
                "position": 1,
                "color": "%c",
                "icon": "controllers/%c/12H",
                "applianceId": null,
            },
            {
                "position": 2,
                "color": "%c",
                "icon": "controllers/%c/11H",
                "applianceId": null,
            },
            {
                "position": 3,
                "color": "%c",
                "icon": "controllers/%c/11I",
                "applianceId": null,
            },
            {
                "position": 4,
                "color": "%c",
                "icon": "controllers/%c/11J",
                "applianceId": null,
            },
            {
                "position": 5,
                "color": "green",
                "icon": "controllers/green/12F",
                "applianceId": null,
            },
            {
                "position": 6,
                "color": "%c",
                "icon": "controllers/%c/1G",
                "applianceId": null,
            }
        ]
    },
    {
        name: 'GRT3-270/',
        type: 'thermostat',
        tech: "bus",
        material: 'glass',
        icons: 7,
        round: true,
        colors: ['black', 'white'],
        colorsShortcut: ['B', 'W'],
        className: 'glass-thermostat-7',
        previewImage: 'grt3-7-round',
        renderImage: 'grt3-round',
        unremoveableIcons: true,
        defaultIconsData: [
            {
                "position": 0,
                "color": "%c",
                "icon": "controllers/%c/1H",
                "applianceId": null,
            },
            {
                "position": 1,
                "color": "%c",
                "icon": "controllers/%c/12H",
                "applianceId": null,
            },
            {
                "position": 2,
                "color": "%c",
                "icon": "controllers/%c/11H",
                "applianceId": null,
            },
            {
                "position": 3,
                "color": "%c",
                "icon": "controllers/%c/11I",
                "applianceId": null,
            },
            {
                "position": 4,
                "color": "%c",
                "icon": "controllers/%c/11J",
                "applianceId": null,
            },
            {
                "position": 5,
                "color": "green",
                "icon": "controllers/green/12F",
                "applianceId": null,
            },
            {
                "position": 6,
                "color": "%c",
                "icon": "controllers/%c/1G",
                "applianceId": null,
            }
        ]
    },
    {
        name: 'GRT3-100/',
        type: 'thermostat',
        tech: "bus",
        material: 'glass',
        icons: 8,
        round: false,
        colors: ['black', 'white'],
        colorsShortcut: ['B', 'W'],
        className: 'glass-thermostat-8',
        iconsScale: 0.5,
        previewImage: 'grt3-8',
        renderImage: 'grt3-100',
        unremoveableIcons: true,
        defaultIconsData: [
            {
                "position": 0,
                "color": "%c",
                "icon": "controllers/%c/2C",
                "applianceId": null,
            },
            {
                "position": 1,
                "color": "%c",
                "icon": "controllers/%c/2D",
                "applianceId": null,
            },
            {
                "position": 2,
                "color": "%c",
                "icon": "controllers/%c/11L",
                "applianceId": null,
            },
            {
                "position": 3,
                "color": "red",
                "icon": "controllers/red/10C",
                "applianceId": null,
            },
            {
                "position": 4,
                "color": "green",
                "icon": "controllers/green/10A",
                "applianceId": null,
            },
            {
                "position": 5,
                "color": "%c",
                "icon": "controllers/%c/1A",
                "applianceId": null,
            },
            {
                "position": 6,
                "color": "%c",
                "icon": "controllers/%c/12C",
                "applianceId": null,
            },
            {
                "position": 7,
                "color": "%c",
                "icon": "controllers/%c/11E",
                "applianceId": null,
            }
        ]
    },
]

export const iconsColor = {
    black: 'white',
    white: 'black',
    silver: 'black',
    brass: 'black',
    copper: 'white'
}